export enum RccapBillable {    
    Unknown = 0,
    Yes = 1,
    No = 2
}